import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useLocale } from '../components/LocaleProvider';
import { SiteLayout } from '../components/SiteLayout';
import { standardPages } from '../data/standardPages';
export function StandardPage() {
  const {
    pathname
  } = useLocation();
  const {
    locale
  } = useLocale();
  const data = standardPages[pathname] ?? standardPages['/about'];
  const request = locale === 'nl' ? 'Informatie aanvragen' : 'Request information';
  return <SiteLayout data-id="element-239" data-mp="3vz4d3ktuuhyx">
      <main data-id="element-240" data-mp="3vyl5awxx59ym">
        <section className="border-b border-ink" data-id="element-241" data-mp="3vy321gcu9vh7">
          <div className="mx-auto grid max-w-[1500px] lg:grid-cols-[1.05fr_0.95fr]" data-id="element-242" data-mp="3qzrsz7udbp01">
            <div className="flex flex-col justify-center px-5 py-16 lg:border-r lg:border-ink lg:px-10 lg:py-24" data-id="element-243" data-mp="3r1uilqrlzg48">
              <p className="font-mono text-[11px] uppercase tracking-label text-cobalt" data-id="element-244" data-mp="1p8emwfgnzb2e">
                {data.eyebrow[locale]}
              </p>
              <h1 className="mt-8 max-w-[18ch] font-display text-[2.75rem] leading-[0.98] tracking-[-0.03em] sm:text-6xl" data-id="element-245" data-mp="1l84ktdvzt4st">
                {data.title[locale]}
              </h1>
              <p className="mt-8 max-w-xl text-lg leading-8 text-ink/70" data-id="element-246" data-mp="366pb18eoqg1w">
                {data.description[locale]}
              </p>
              <Link to="/contact" className="mt-10 inline-block w-fit border border-ink bg-ink px-6 py-4 font-mono text-[11px] uppercase tracking-[0.16em] text-paper transition hover:border-cobalt hover:bg-cobalt" data-id="element-247" data-mp="2s88wwwehtn9q">
                {request}
              </Link>
            </div>
            <img src={data.image} alt="" className="h-full min-h-[320px] w-full object-cover" data-id="element-248" data-mp="3oyrj3vd9go0j" />
          </div>
        </section>
        <section data-id="element-249" data-mp="3f5ancltkcyu8">
          <div className="mx-auto max-w-[1500px] px-5 py-16 lg:px-10" data-id="element-250" data-mp="3f4rahjirt0n2">
            <div className="border-t border-ink" data-id="element-251" data-mp="6q0s9xo3ctvy">
              {data.sections.map((section, index) => <article key={section.title.nl} className="grid gap-6 border-b border-stone py-10 md:grid-cols-[4rem_1fr_1.2fr] md:gap-10" data-id="element-252" data-mp="bk50sld099z5" data-mpi={index}>
                  <span className="font-mono text-[11px] text-cobalt" data-id="element-253" data-mp="hd73quv86fva">
                    {String(index + 1).padStart(2, '0')}
                  </span>
                  <h2 className="font-display text-3xl leading-tight tracking-[-0.02em]" data-id="element-254" data-mp="7ergx438dsrl">
                    {section.title[locale]}
                  </h2>
                  <p className="leading-8 text-ink/70" data-id="element-255" data-mp="2h9elwjpybsk">
                    {section.body[locale]}
                  </p>
                </article>)}
            </div>
          </div>
        </section>
      </main>
    </SiteLayout>;
}